module.exports = __webpack_public_path__ + "static/media/expressjs.67e90358.svg";